export const formatInteger = (val: number): string => {
	val = Math.floor(val);
	return val + '';
};
